import {Component} from '@angular/core';
import {Constant} from '../../../global/util/Constant';
import {ApplicationService} from '../../service/application.service';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {InformType} from '../../../global/util/enum/InformType';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Dialog} from '../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-global-config',
  templateUrl: './global-config.component.html',
  styleUrls: ['./global-config.component.css']
})
export class GlobalConfigComponent {

  public title = 'TITLE.GLOBAL-SETTINGS';
  public loading: boolean;

  constructor(private applicationService: ApplicationService,
              private modalService: NgbModal,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  public reload() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/staticdata/reload');
    this.applicationService.get(url).subscribe(value => {
      this.loading = false;
      Dialog.show(InformType.Success, this.translate.instant('TITLE.GLOBAL-SETTINGS'));
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.GLOBAL-SETTINGS'), error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info,  this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }
}
